import React from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

import NavigationSideCollapsedMenu from './collapsed/Menu';
import NavigationSideExpandedMenu from './expanded/Menu';

const NavigationSideMenu = ({ sideMenuCollapsed, setSideMenuCollapsed, ...props }) => (
  <div className="st-side-navigation-menu-container">
    {sideMenuCollapsed ? (
      <NavigationSideCollapsedMenu {...props} />
    ) : (
      <NavigationSideExpandedMenu {...props} />
    )}
    <div className="st-side-menu-expander" onClick={setSideMenuCollapsed} onKeyDown={() => {}}>
      {sideMenuCollapsed ? (
        <RightOutlined style={{ color: '#808080' }} />
      ) : (
        <LeftOutlined style={{ color: '#808080' }} />
      )}
    </div>
  </div>
);

export default NavigationSideMenu;
